const fuelEventTypeStyles: Record<number, {label: string; className: string}> =
  {
    1: {
      label: "Fuel Fill",
      className: "bg-[#EAF8EF] text-[#22A447]"
    },
    2: {
      label: "Low Fuel",
      className: "bg-[#FFF8E7] text-[#F5A400]"
    },
    3: {
      label: "Fuel theft",
      className: "bg-[#FFE9E9] text-[#FF2D3D]"
    },
    4: {
      label: "No Data",
      className: "bg-gray-100 text-gray-600"
    }
  };

export const getFuelEventType = (value: any) => {
  const numericType = Number(value);
  if (Number.isFinite(numericType) && fuelEventTypeStyles[numericType]) {
    return numericType;
  }

  const normalizedValue = String(value ?? "")
    .trim()
    .toLowerCase();

  if (
    ["fuel fill", "fuel filling", "refill", "refilling"].includes(
      normalizedValue
    )
  ) {
    return 1;
  }

  if (["low fuel", "lowfuel"].includes(normalizedValue)) {
    return 2;
  }

  if (["fuel theft", "fuel drop", "theft"].includes(normalizedValue)) {
    return 3;
  }

  if (["no data", "nodata"].includes(normalizedValue)) {
    return 4;
  }

  return null;
};

export const formatFuelStatus = (value: any) => {
  const eventType = getFuelEventType(value);
  return eventType ? fuelEventTypeStyles[eventType].label : value || "-";
};

export const NeoFuelStatus: React.FC<any> = ({data, uid}) => {
  const value = data?.[uid];
  const eventType = getFuelEventType(value);
  const eventTypeStyle = eventType
    ? fuelEventTypeStyles[eventType]
    : {
        label: value,
        className: "bg-gray-100 text-gray-600"
      };

  return (
    <span
      className={`inline-flex items-center justify-center rounded-md px-2 py-1 text-sm font-medium ${eventTypeStyle.className}`}
    >
      {eventTypeStyle.label}
    </span>
  );
};
